/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCrmOpportunityInput
 */
export interface CreateCrmOpportunityInput {
    /**
     * 
     * @type {string}
     * @memberof CreateCrmOpportunityInput
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCrmOpportunityInput
     */
    contactName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCrmOpportunityInput
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCrmOpportunityInput
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCrmOpportunityInput
     */
    initialNote?: string | null;
}

/**
 * Check if a given object implements the CreateCrmOpportunityInput interface.
 */
export function instanceOfCreateCrmOpportunityInput(value: object): value is CreateCrmOpportunityInput {
    return true;
}

export function CreateCrmOpportunityInputFromJSON(json: any): CreateCrmOpportunityInput {
    return CreateCrmOpportunityInputFromJSONTyped(json, false);
}

export function CreateCrmOpportunityInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCrmOpportunityInput {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'contactName': json['contactName'] === undefined ? undefined : json['contactName'] === null ? null : json['contactName'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'initialNote': json['initialNote'] === undefined ? undefined : json['initialNote'] === null ? null : json['initialNote'],
    };
}

export function CreateCrmOpportunityInputToJSON(json: any): CreateCrmOpportunityInput {
    return CreateCrmOpportunityInputToJSONTyped(json, false);
}

export function CreateCrmOpportunityInputToJSONTyped(value?: CreateCrmOpportunityInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'contactName': value['contactName'],
        'email': value['email'],
        'phone': value['phone'],
        'initialNote': value['initialNote'],
    };
}

